import React from 'react'
import { useState } from 'react';
import { Slider } from "rsuite"

import { Form, Row, Col } from 'react-bootstrap';

import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import RangeSlider from 'react-bootstrap-range-slider';


function Range() {

    const [value, setValue] = useState(0);

    function handleOnChange(e) {
        setValue(e.target.value);
        console.log(value);
    }

    // const labels = ['Off', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25'];

    return (
        <>

            <form>
                <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-10 col-10">
                        <RangeSlider
                            min={0}
                            max={25}
                            tooltip={"off"}
                            value={value}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2 p-0">
                        <input className='form-control' value={value == 0 ? "Off" : value} style={{ border: "1px solid #ced4da", width: "30px", height: "30px", fontSize: "12px", textAlign: "center", padding: "0.375rem 0" }} />
                    </div>
                </div>
            </form>


            {/* <div style={{ width: 390, marginLeft: 11 }}>
                <Slider
                    min={0}
                    max={labels.length - 1}
                    value={value}
                    className="custom-slider"
                    handleStyle={{
                        borderRadius: 10,
                        color: '#fff',
                        fontSize: 12,
                        width: 'auto',
                        height: 22
                    }}
                    graduated
                    tooltip={false}
                    handleTitle={labels[value]}
                    onChange={setValue}
                />
            </div> */}
        </>
    )
}

export default Range
